// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__3Z-Vt","title":"AfterFrontImage_title__q5qKc"};